<template>
    <div class="main-div">
        <HeaderUploadFile @closeDialog="closeDialog"  />
        <MainUploadFile />
        <FooterUploadFile @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import FooterUploadFile from './FooterUploadFile.vue';
import HeaderUploadFile from './HeaderUploadFile.vue';
import MainUploadFile from './MainUploadFile.vue';

const dialogRef =   getDialogRef(ModalNames.UPLOAD_FILE);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-lg sm:w-[480px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>
